const PATHICON_LIST_ITEM_CLASS_PATTERN = /^pwai-[A-Za-z0-9_-]+$/

export function getPathiconListItemClassName(className: unknown): string | null {
  if (typeof className !== "string") return null

  const pathiconClasses = className
    .split(/\s+/)
    .filter((classToken) => PATHICON_LIST_ITEM_CLASS_PATTERN.test(classToken))

  return pathiconClasses.length ? pathiconClasses.join(" ") : null
}

export const PATHICON_LIST_STYLES = {
  "& li[class^='pwai-']": {
    marginBlock: "0.2rem",
  },
  "& li[class^='pwai-'] p": {
    marginBlock: "0",
  }
}
